import AccessTimeIcon from '@mui/icons-material/AccessTime';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useController } from 'react-hook-form';

import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import { useAvailabilitiesContext } from 'reservations/availabilities/providers/AvailabilitiesProvider';
import { getAvailabilitiesFormItemStyles } from 'reservations/brand/helpers/v1/styles';

type TimePickerSlot = {
  time?: string;
  index: number;
};

const TimePicker = () => {
  const { timePickerSlots } = useAvailabilitiesContext();
  const {
    field: { onChange, name, value, ref, onBlur }
  } = useController({
    name: 'time'
  });
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  return (
    <FormControl
      fullWidth
      sx={getAvailabilitiesFormItemStyles(hasBrandEngineFeature)}
    >
      <InputLabel id="reservations-time">Time</InputLabel>
      <Select
        disabled={timePickerSlots.length <= 1}
        labelId="reservations-time"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        inputRef={ref}
        label="Time"
        IconComponent={KeyboardArrowDownIcon}
        startAdornment={
          <InputAdornment position="start">
            <AccessTimeIcon />
          </InputAdornment>
        }
      >
        {timePickerSlots.map((option: TimePickerSlot) => {
          // NOTE: this is the case where the value we choose for time is Anytime
          // we want to make sure that the value is outside of the range of the array
          // of TimePickerSlots
          return (
            <MenuItem value={option.index} key={option.time}>
              {option.time}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default TimePicker;
